export default "__VITE_ASSET__CknoylQb__"